import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { Tooltip } from 'react-wot-bootstrap'
import classNames from 'classnames'

import { STRONGHOLD as STRONGHOLD_URL } from 'urls'
import { canActivateReserves } from 'helpers/accounts'
import ReserveBlock from './components/ReserveBlock'
import {
    sendEnterStrongholdSoundState,
    playEnterStrongholdSound,
    playHoverSound,
    playClickSound,
} from 'state/actions/sounds'

import {
    BOXES_COUNT,
    COMMANDER_TOOLTIP_TEXT,
    HEADER_MESSAGE,
    NEW_RESERVE_TOOLTIP_ID,
    RESERVES_TO_SHOW,
} from './constants'

import styles from './ClanLandingReserves.scss'

export class ClanLandingReserves extends React.Component {
    static propTypes = {
        canActivate: PropTypes.bool.isRequired,
        reserves: PropTypes.array.isRequired,
        reserveGroups: PropTypes.object.isRequired,
        reserveSettings: PropTypes.object.isRequired,

        openStronghold: PropTypes.func.isRequired,
        sendEnterStrongholdSoundState: PropTypes.func.isRequired,
        playEnterStrongholdSound: PropTypes.func.isRequired,
        playClickSound: PropTypes.func.isRequired,
        playHoverSound: PropTypes.func.isRequired,
    }

    state = { reserves: [] }

    componentDidMount() {
        this.update()
    }

    componentDidUpdate() {
        if (this.props.reserves.length && !this.timeoutId)
            this.update()
    }

    componentWillUnmount() {
        this.clearTimeouts()
    }
    handleOpenStronghold = () => {
        this.props.openStronghold()
        this.props.playClickSound()
        this.props.sendEnterStrongholdSoundState()
        this.props.playEnterStrongholdSound()
    }

    update = () => {
        this.clearTimeouts()

        const now = Date.now()
        const isEffectActive = reserves =>
            reserves.some(reserve => reserve.effectEnds > now)
        const reserves = this.props.reserves.filter(isEffectActive)

        this.setState({ reserves })
        if (reserves.length)
            this.timeoutId = setTimeout(this.update, 1000)
    }

    clearTimeouts() {
        if (this.timeoutId) clearTimeout(this.timeoutId)
    }

    render() {
        const { canActivate, reserveGroups, reserveSettings } = this.props

        const reserves = this.state.reserves

        if (!canActivate && !reserves.length) return null

        let emptyBoxes = []
        if (reserves.length < BOXES_COUNT && canActivate)
            emptyBoxes = Array.from({ length: BOXES_COUNT - reserves.length }, () => null)

        const classNamesHeader = classNames(styles.header, {
            [styles.header__fullSize]: reserves.length === 2,
        })
        const getTooltipId = index => `${NEW_RESERVE_TOOLTIP_ID}_${index}`
        return (
            <div className={styles.base}>
                <div className={classNamesHeader}>
                    {HEADER_MESSAGE}
                </div>
                <div className={styles.reservesWrapper}>
                    {reserves.map(reserveList => (
                        <ReserveBlock
                            key={reserveList[0].type}
                            reserveType={reserveList[0].type}
                            reserveList={reserveList}
                            reserveSettings={reserveSettings}
                            reserveGroups={reserveGroups}
                            openStronghold={this.handleOpenStronghold}
                            playHoverSound={this.props.playHoverSound}
                        />
                    ))}
                    {emptyBoxes.map((_, index) => (
                        <figure
                            className={styles.reserveContainer}
                            key={index}
                            onClick={this.handleOpenStronghold}
                            onMouseEnter={this.props.playHoverSound}
                        >
                            <div
                                className={styles.blankImage}
                                data-tip
                                data-for={getTooltipId(index)}
                            />
                            <Tooltip id={getTooltipId(index)}>{COMMANDER_TOOLTIP_TEXT}</Tooltip>
                        </figure>
                    ))}
                </div>
            </div>
        )
    }
}

export const mapStateToProps = ({ account, clanReserves, settings }) => {
    const { reserves: reserveSettings, reserve_groups: reserveGroups } = settings
    const canActivate = canActivateReserves(account)

    const effective = reserve => reserve.is_effective
    const compareActivity = (reserveList1, reserveList2) =>
        reserveList1.find(effective).effectEnds - reserveList2.find(effective).effectEnds
    const shouldShow = reserveList =>
        reserveList.length && RESERVES_TO_SHOW.includes(reserveList[0].type) && reserveList.some(effective)

    const reserves = Object.values(clanReserves)
        .filter(shouldShow)
        .sort(compareActivity)

    return {
        canActivate,
        reserves,
        reserveGroups,
        reserveSettings,
    }
}
const mapDispatchToProps = {
    openStronghold: () => push(STRONGHOLD_URL),
    sendEnterStrongholdSoundState,
    playEnterStrongholdSound,
    playHoverSound,
    playClickSound,
}

export default connect(mapStateToProps, mapDispatchToProps)(ClanLandingReserves)



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanLandingReserves/ClanLandingReserves.jsx